/* eslint-disable */


const AppIcons = {
    slider1: require('./slider1.jpeg'),
    slider2: require('./slider2.png'),
    asclepius: require('../Asclepius.png'),
    // logo: require('../logo.png'),
    logo: require('./logo.png'),
    smLogo: require('../smLogo.png'),

    loginBG1: require('../loginBG1.png'),
    fileIcon: require('./fileIcon.png'),
    userPlaceholder: require('./userPlaceholder.png'),


    avatar1: require('./avatar/avatar1.png'),
    avatar2: require('./avatar/avatar2.png'),
    avatar3: require('./avatar/avatar3.png'),
    avatar4: require('./avatar/avatar4.png'),
    avatar5: require('./avatar/avatar5.png'),
    avatar6: require('./avatar/avatar6.png'),
    avatar7: require('./avatar/avatar7.png'),
    avatar8: require('./avatar/avatar8.png'),
    avatar9: require('./avatar/avatar9.png'),
    avatar10: require('./avatar/avatar10.png'),
    avatar11: require('./avatar/avatar11.png'),
    avatar12: require('./avatar/avatar12.png'),
    avatar13: require('./avatar/avatar13.png'),
    avatar14: require('./avatar/avatar14.png'),
    avatar15: require('./avatar/avatar15.png'),
    avatar16: require('./avatar/avatar16.png'),
    avatar17: require('./avatar/avatar17.png'),

    hAvatar1: require('./humanLookAvatar/hAvatar1.png'),
    hAvatar2: require('./humanLookAvatar/hAvatar2.png'),
    hAvatar3: require('./humanLookAvatar/hAvatar3.png'),
    hAvatar4: require('./humanLookAvatar/hAvatar4.png'),
    hAvatar5: require('./humanLookAvatar/hAvatar5.png'),
    hAvatar6: require('./humanLookAvatar/hAvatar6.png'),
    hAvatar7: require('./humanLookAvatar/hAvatar7.png'),
    hAvatar8: require('./humanLookAvatar/hAvatar8.png'),
    hAvatar9: require('./humanLookAvatar/hAvatar9.png'),
    hAvatar10: require('./humanLookAvatar/hAvatar10.png'),

    bAvatar1: require('./botLookAvatar/bAvatar1.png'),
    bAvatar2: require('./botLookAvatar/bAvatar2.png'),
    bAvatar3: require('./botLookAvatar/bAvatar3.png'),
    bAvatar4: require('./botLookAvatar/bAvatar4.png'),
    bAvatar5: require('./botLookAvatar/bAvatar5.png'),
    bAvatar6: require('./botLookAvatar/bAvatar6.png'),
    bAvatar7: require('./botLookAvatar/bAvatar7.png'),
    bAvatar8: require('./botLookAvatar/bAvatar8.png'),
    bAvatar9: require('./botLookAvatar/bAvatar9.png'),
    bAvatar10: require('./botLookAvatar/bAvatar10.png'),
    bAvatar11: require('./botLookAvatar/bAvatar11.png'),
    bAvatar12: require('./botLookAvatar/bAvatar12.png'),
    bAvatar13: require('./botLookAvatar/bAvatar13.png'),
    bAvatar14: require('./botLookAvatar/bAvatar14.png'),
    bAvatar15: require('./botLookAvatar/bAvatar15.png'),
    bAvatar16: require('./botLookAvatar/bAvatar16.png'),
    bAvatar17: require('./botLookAvatar/bAvatar17.png'),
    bAvatar18: require('./botLookAvatar/bAvatar18.png'),
    bAvatar19: require('./botLookAvatar/bAvatar19.png'),

    chatHead1: require('../chatHeaders/chatHead1.png'),
    chatHead2: require('../chatHeaders/chatHead2.png'),
    chatHead3: require('../chatHeaders/chatHead3.png'),
    chatHead4: require('../chatHeaders/chatHead4.png'),
    chatHead5: require('../chatHeaders/chatHead5.png'),
    chatHead6: require('../chatHeaders/chatHead6.png'),
    chatHead7: require('../chatHeaders/chatHead7.png'),

    chatPreview: require('../chatPreview.png'),
    preview1: require('../preview1.png'),
    preview2: require('../preview2.png'),
    preview3: require('../preview3.png'),

    ChatWindowPreview: require('../ChatWindowPreview.png'),
    ChatboxPreview: require('../ChatboxPreview.png'),
    chatBot: require('../chatBot.png'),
    defaultLogo: require('../defaultLogo.png'),
    defaultLogoImg: require('../defaultLogoImg.png'),

    themeBGLight: require('../themeBG/light.png'),
    themeBGGrey: require('../themeBG/grey.png'),
    themeBGDark: require('../themeBG/dark.png'),
    themeBGColor: require('../themeBG/color.png'),
    themeBGFlash: require('../themeBG/flash.png'),
    themeBGDarkPurple: require('../themeBG/darkPurple.png'),

    mobileThemeHeadLogo: require('../mobileTheme/mobileThemeHeadLogo.png'),
    mobileThemeHeadClose: require('../mobileTheme/mobileThemeHeadClose.png'),
    mobileThemeHeadMaximize: require('../mobileTheme/mobileThemeHeadMaximize.png'),
    mobileThemeHeadCloseBlk: require('../mobileTheme/mobileThemeHeadCloseBlk.png'),
    mobileThemeHeadMaximizeBlk: require('../mobileTheme/mobileThemeHeadMaximizeBlk.png'),
    mobileThemeChatInput: require('../mobileTheme/mobileThemeChatInput.png'),
    



}

export default AppIcons;
